import React, { useState } from "react";

import PatentTable from "../../containers/Patent/PatentTable";
import PatentButton from "../../containers/Patent/PatentButton";

function Patent(props) {
  const list = window.location.href.split("/");
  const lastValueList = list[list.length - 1].split("=");
  const selectedProfileId = lastValueList.length > 1 ? lastValueList[lastValueList.length - 1] : null;
  const [updating, setUpdating] = useState(null);

  return (
    <div style={{ padding: 8, minHeight: "calc(100vh - 200px)", maxHeight: "calc(100vh - 200px)" }}>
      <PatentButton
        type={props.type}
        department={props.department}
        selectedProfileId={selectedProfileId}
        handleReload={props.handleReload}
        setUpdating={setUpdating}
      />
      <PatentTable
        adminTab={props.adminTab}
        type={props.type}
        department={props.department}
        selectedProfileId={selectedProfileId}
        handleReload={props.handleReload}
        updating={updating}
        setUpdating={setUpdating}
      />
    </div>
  );
}

export default Patent;

